export default __webpack_public_path__ + "0dd021182d55734a8d86fe973dfa56b1.png";